import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from 'react-router-dom';
import { useGetTicketsQuery } from './ticketsApiSlice';
import { memo } from 'react';

const Ticket = ({ ticketId }) => {
    const { ticket } = useGetTicketsQuery("ticketsList", {
        selectFromResult: ({ data }) => ({
            ticket: data?.entities[ticketId]
        }),
    });

    const navigate = useNavigate();

    if (ticket) {
        const created = new Date(ticket.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long' });
        const updated = new Date(ticket.updatedAt).toLocaleString('en-US', { day: 'numeric', month: 'long' });

        const handleEdit = () => navigate(`/dash/tickets/${ticketId}`);

        return (
            <tr className="text-center text-[10px] md:text-[15px] border-b border-slate-600">
                <td className="text-center w-[9.32rem] py-2">
                    {ticket.completed
                        ? <span className=" bg-green-300 px-2 py-1 rounded text-black">Closed</span>
                        : <span className=" bg-yellow-200 px-2 py-1 rounded text-black">In Progress</span>
                    }
                </td>
                <td className="text-center border-l border-slate-600 w-[8.52rem] py-2">{created}</td>
                <td className="text-center border-l border-slate-600 w-[9.1rem] py-2"> {updated}</td>
                <td className="border-l border-slate-600 w-[23.2rem] py-2">{ticket.title}</td>
                <td className="text-center border-l border-slate-600 w-[9.8rem] py-2">{ticket.username}</td>

                <td className="border-l border-slate-600 w-[8.7rem]">
                    <button
                        className=" bg-blue-500 hover:bg-blue-700 px-2 py-1 rounded"
                        onClick={handleEdit}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                </td>
            </tr>
        );
    } else {
        return null;
    }
};

const memoizedTicket = memo(Ticket);

export default memoizedTicket;
